<template>
  <div class="login-shell">
    <div class="row login-container">
    <!-- Logo section for mobile view -->
    <div class="col-12 d-md-none mobile-logo text-center">
      <img src="../assets/unodc-logo-white.png" class="img-fluid mobile-logo-img mt-2" />
    </div>

    <!-- Left section with background image -->
    <div
      class="col-lg-9 col-md-7 col-sm-12 bg d-none d-md-flex"
      :style="{ backgroundImage: 'url(' + require('@/assets/login-bg.jpg') + ')' }"
    >
      <div class="container-fluid">
        <div class="row">
          
          <div class="col-sm-8 offset-sm-2 left-panel">
            <img src="../assets/UNODC-logo-full.png" class="img-responsive tablet-logo desktop-logo" />
            <div class="news-card mt-4">
              <h3 class="news-card-heading">COPAK News</h3>
              <div class="news-content">
                <transition name="story-fade" mode="out-in">
                  <ul
                    class="news-list"
                    :key="'batch-' + storyBatchIndex + '-' + storyBatchKey"
                  >
                    <li v-for="story in activeStoryBatch" :key="story.url || story.title">
                      <a :href="story.url" target="_blank" rel="noopener">
                      <span class="story-icon">
                        <span class="story-icon-month">{{ formatStoryMonth(story.date) }}</span>
                        <span class="story-icon-day">{{ formatStoryDay(story.date) }}</span>
                      </span>
                      <span class="story-line">
                        <span class="story-title">{{ story.title }}</span>
                      </span>
                    </a>
                  </li>
                </ul>
              </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Login form section -->
    <div class="col-lg-3 col-md-5 col-sm-12 bg-blue">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12 text-center login-form-container">
            <h6 class="text-white text-uppercase mb-4">login</h6>
            <div class="alert alert-danger" v-if="error">{{ error }}</div>
            <form action="#" @submit.prevent="loginForm">
              <div class="form-group">
                <label class="sr-only" for="email">Email or Username</label>
                <div class="input-pill">
                  <span class="input-icon" aria-hidden="true">&#128100;</span>
                  <input
                    ref="emailInput"
                    type="text"
                    v-model="username"
                    class="form-control login-input"
                    placeholder="Email address or username"
                    id="email"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="sr-only" for="pwd">Password</label>
                <div class="input-pill">
                  <span class="input-icon" aria-hidden="true">&#128274;</span>
                  <input
                    v-model="password"
                    type="password"
                    class="form-control login-input"
                    placeholder="Password"
                    id="pwd"
                  />
                </div>
              </div>

              <button
                type="submit"
                class="btn btn-black btn-login mt-3 btn-sm"
              >
                Login
              </button>
<br /><br /><Br /><br /><br /><Br /><br />
              <div class="forgot-wrapper mt-4">
                <router-link class="btn btn-outline-light forgot-btn" to="/forgotPassword"
                  >Forgot Password?</router-link
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
    <footer class="login-footer">
      M&E Unit - United Nations Office on Drugs and Crime - COPAK
    </footer>
  </div>
</template>

<script>

import axios from "axios";

const FALLBACK_STORIES = [
  {
    title: "Enhancing the role of forensic evidence in judicial decision-making in Balochistan",
    url: "https://www.unodc.org/copak/en/Stories/SP2/enhancing-the-role-of-forensic-evidence-in-judicial-decision-making-in-balochistan.html",
    date: "1 December 2025",
  },
  {
    title: "University of Narowal launches National Incubation Centre for Social Entrepreneurship",
    url: "https://www.unodc.org/copak/en/Stories/SP4/university-of-narowal-launches-national-incubation-centre-for-social-entrepreneurship.html",
    date: "1 December 2025",
  },
  {
    title: "Strengthening Cross-Regional Action to Counter the Smuggling of Migrants - International Conference Hosted by Pakistan",
    url: "https://www.unodc.org/copak/en/Stories/SP1/strengthening-cross-regional-action-to-counter-the-smuggling-of-migrants---international-conference-hosted-by-pakistan.html",
    date: "28 November 2025",
  },
  {
    title: "Following the Money: How Illicit Flows Shape Global Challenges",
    url: "https://www.unodc.org/copak/en/Stories/SP2/following-the-money_-how-illicit-flows-shape-global-challenges.html",
    date: "25 November 2025",
  },
  {
    title: "Private Sector and Financial Institutions Join Efforts to Identify Illicit Flows Linked to Migrant Smuggling",
    url: "https://www.unodc.org/copak/en/Stories/SP2/private-sector-and-financial-institutions-join-efforts-to-identify-illicit-flows-linked-to-migrant-smuggling.html",
    date: "25 November 2025",
  },
  {
    title: "Empowering prosecutors in Punjab to deliver smart justice to citizens through enhanced CFMS",
    url: "https://www.unodc.org/copak/en/Stories/SP2/empowering-prosecutors-in-punjab-to-deliver-smart-justice-to-citizens-through-enhanced-cfms.html",
    date: "20 November 2025",
  },
  {
    title: "Strengthening National Networks for Youth Leadership & Victim Support in PVE",
    url: "https://www.unodc.org/copak/en/Stories/SP4/strengthening-national-networks-for-youth-leadership-and-victim-support-in-pve.html",
    date: "20 November 2025",
  },
  {
    title: "Strengthening Communications Narratives – UNODC Holds Follow-up Workshop for Civil Society Partners working on countering violent extremism",
    url: "https://www.unodc.org/copak/en/Stories/SP4/strengthening-communications-narratives--unodc-holds-follow-up-workshop-for-civil-society-partners-working-on-countering-violent-extremism.html",
    date: "3 November 2025",
  },
  {
    title: "Empowering prosecutors for faster, fairer, and more transparent digital justice in Punjab",
    url: "https://www.unodc.org/copak/en/Stories/SP2/empowering-prosecutors-for-faster--fairer--and-more-transparent-digital-justice-in-punjab.html",
    date: "30 October 2025",
  },
  {
    title: "Empowering prosecutors in Balochistan through forensic knowledge and expertise",
    url: "https://www.unodc.org/copak/en/Stories/SP2/empowering-prosecutors-in-balochistan-through-forensic-knowledge-and-expertise.html",
    date: "30 October 2025",
  },
];

const UNODC_STORIES_URL = "https://www.unodc.org/copak/en/stories.html";
const ALL_ORIGINS = "https://api.allorigins.win/raw?url=";
const MARKDOWN_STORIES_URL =
  "https://r.jina.ai/https://www.unodc.org/copak/en/stories.html";
const MAX_STORIES = 10;
const STORIES_PER_BATCH = 5;

export default {
  data() {
    return {
      username: "",
      password: "",
      stories: FALLBACK_STORIES.slice(),
    storyBatchIndex: 0,
    storyBatchKey: 0,
    storyTimer: null,
    storyRotationInterval: 10000,
    storyBatches: [],
    error: "",
    storyThumbnailCache: {},
    lastStoryFetchAt: 0,
  };
},
  mounted() {
    this.isLoggedIn();
    if (this.$refs.emailInput) {
      this.$refs.emailInput.focus();
    }
    this.storyBatches = this.buildStoryBatches(this.topStories);
    this.refreshStories();
  },

  beforeDestroy() {
    this.clearStoryTimer();
  },

  activated() {
    this.refreshStories();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => vm.refreshStories());
  },

  beforeRouteUpdate(to, from, next) {
    this.refreshStories();
    next();
  },
  computed: {
    topStories() {
      const baseStories =
        this.stories && this.stories.length ? this.stories : FALLBACK_STORIES;
      const selected = [...baseStories.slice(0, MAX_STORIES)];
      if (selected.length < MAX_STORIES) {
        for (const fallback of FALLBACK_STORIES) {
          if (selected.length >= MAX_STORIES) {
            break;
          }
          if (!selected.some((story) => story.url === fallback.url)) {
            selected.push(fallback);
          }
        }
      }
      while (selected.length < MAX_STORIES) {
        selected.push(FALLBACK_STORIES[0]);
      }
      return selected;
    },
    storyChunks() {
      return this.storyBatches.length
        ? this.storyBatches
        : [FALLBACK_STORIES.slice(0, STORIES_PER_BATCH)];
    },
    activeStoryBatch() {
      return (
        this.storyChunks[this.storyBatchIndex] ||
        this.storyChunks[0] ||
        FALLBACK_STORIES.slice(0, STORIES_PER_BATCH)
      );
    },
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    loginForm(e) {
      e.preventDefault();
      let self = this;
      let noAccess = "";
      self.openLoading();
      
      axios.post(process.env.VUE_APP_BASE_PATH + "/login/user", {
        username: this.username,
        password: this.password
      })
      .then(function(response) {
        self.closeLoading();
        if (response.data.success) {
          let isPermission = response.data.success.user.roles.permission;
          localStorage.setItem(
            "currentUser",
            JSON.stringify(response.data.success.user)
          );
          localStorage.setItem("isPermission", isPermission);
          localStorage.setItem("token", response.data.success.token);
          localStorage.setItem("auth", response.data.success.auth);
          localStorage.setItem("version", response.data.success.user.version_no);


          if (localStorage.getItem("token") != null) {
            // This will redirect to admin dashboard
            if (
              isPermission == "admin" ||
              isPermission == "admin_expert" ||
              isPermission == "admin_officer" ||
              isPermission == "admin_associate" ||
              isPermission == "admin_assistant"
            ) {
              self.$router.push("/dashboard/Admin/adminDashboardView"); // the router object
              // /main-dashboard
            }
            // This will redirect to Advisor/Senior Program Officer
            else if (isPermission == "advisor") {
              self.$router.push("/dashboard/Advisor/advisordashboardView"); // the router object
            }
            // This will redirect to trainer dashboard
            else if (isPermission == "trainer") {
              self.$router.push("/dashboard/Trainer/trainerPrevTraining"); // the router object
            }
            // This will redirect to trainee
            else if (isPermission == "trainee") {
              self.$router.push("/dashboard/Trainee/traineeDashboard"); // the router object
            }
            // This will redirect to Program Officer
            else if (
              isPermission == "program_officer" ||
              isPermission == "program_assistant" ||
              isPermission == "program_coordinator" ||
              isPermission == "program_associate"
            ) {
              self.$router.push("/dashboard/programOfficer/officerDashboardView"); // the router object
            }
            // This will redirect to Communucation Officer
            else if (isPermission == "comm_officer") {
              self.$router.push("/dashboard/communicationOfficer/dashboardCO"); // the router object
            }
            // This will redirect to Country Representative
            else if (isPermission == "country_represent") {
              self.$router.push("/dashboard/CountryRepresentative/dashboard"); // the router object
            }
             else {
              noAccess = "Your are not authorized to access";
              self.error = noAccess;
            }
          }
        } else if (response.data.error) {
          self.error = response.data.error;
        }
      });
    },

    // This will check if user is already login or not
    isLoggedIn() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      let self = this;
      let noAccess = "";
      if (localStorage.getItem("token") != null && currentUser) {
        // This will redirect to admin dashboard
        if (
          currentUser.roles.permission == "admin" ||
          currentUser.roles.permission == "admin_expert" ||
          currentUser.roles.permission == "admin_officer" ||
          currentUser.roles.permission == "admin_associate" ||
          currentUser.roles.permission == "admin_assistant"
        ) {
          self.$router.push("/dashboard/Admin/adminDashboardView"); // the router object
          // main-dashboard
        }
        // This will redirect to Advisor/Senior Program Officer
        else if (currentUser.roles.permission == "advisor") {
          self.$router.push("/dashboard/Advisor/advisordashboardView"); // the router object
        }
        // This will redirect to trainer dashboard
        else if (currentUser.roles.permission == "trainer") {
          self.$router.push("/dashboard/Trainer/trainerPrevTraining"); // the router object
        }
        // This will redirect to trainee
        else if (currentUser.roles.permission == "trainee") {
          self.$router.push("/dashboard/Trainee/traineeDashboard"); // the router object
        }
        // This will redirect to Program Officer
        else if (
          currentUser.roles.permission == "program_officer" ||
          currentUser.roles.permission == "program_assistant" ||
          currentUser.roles.permission == "program_coordinator" ||
          currentUser.roles.permission == "program_associate"
        ) {
          self.$router.push("/dashboard/programOfficer/officerDashboardView"); // the router object
        }
        // This will redirect to Communucation Officer
        else if (currentUser.roles.permission == "comm_officer") {
          self.$router.push("/dashboard/communicationOfficer/dashboardCO"); // the router object
        }
        // This will redirect to Country Representative
        else if (currentUser.roles.permission == "country_represent") {
          self.$router.push("/dashboard/CountryRepresentative/dashboard"); // the router object
        } else {
          noAccess =
            "Your session has been expired. Try again to login please!";
          self.error = noAccess;
        }
      } else {
        return false;
      }
    },

    getStoriesProxyUrl() {
      const basePath = (process.env.VUE_APP_BASE_PATH || "").replace(/\/$/, "");
      return basePath ? `${basePath}/copak-stories` : "/copak-stories";
    },

    async fetchStories() {
      let html = "";
      try {
        html = await this.fetchStoriesFromProxy();
      } catch (proxyError) {
        console.warn("Proxy COPAK fetch failed:", proxyError);
      }

      if (!html) {
        try {
          html = await this.fetchStoriesFromAllOrigins();
        } catch (fallbackError) {
          console.warn("AllOrigins COPAK fetch failed:", fallbackError);
        }
      }

      let parsedStories = [];
      if (html) {
        parsedStories = this.extractStoriesFromHtml(html);
      }

      if (!parsedStories.length) {
        try {
          const markdown = await this.fetchStoriesFromMarkdown();
          parsedStories = this.extractStoriesFromMarkdown(markdown);
        } catch (markdownError) {
          console.warn("Markdown COPAK fetch failed:", markdownError);
        }
      }

      this.stories = parsedStories.length ? parsedStories : FALLBACK_STORIES.slice();
      this.storyBatches = this.buildStoryBatches(this.topStories);
      await this.ensureStoryThumbnails(this.topStories);
      this.resetStoryRotation();
    },

    buildStoryBatches(stories) {
      const dataset = [...stories].slice(0, MAX_STORIES);
      const batches = [];
      for (let index = 0; index < dataset.length; index += STORIES_PER_BATCH) {
        batches.push(dataset.slice(index, index + STORIES_PER_BATCH));
      }
      return batches.length
        ? batches
        : [FALLBACK_STORIES.slice(0, STORIES_PER_BATCH)];
    },

    async refreshStories() {
      this.clearStoryTimer();
      this.storyBatches = [];
      this.storyBatchIndex = 0;
      this.storyBatchKey += 1;
      this.stories = [];
      this.lastStoryFetchAt = Date.now();
      await this.fetchStories();
    },

    async ensureStoryThumbnails() {
      return Promise.resolve();
    },

    async fetchStoriesFromProxy() {
      const cacheBuster = `cb=${Date.now()}`;
      const url = `${this.getStoriesProxyUrl()}?${cacheBuster}`;
      const response = await axios.get(url, {
        timeout: 15000,
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });
      return typeof response.data === "string" ? response.data : "";
    },

    async fetchStoriesFromAllOrigins() {
      const cacheBuster = `cb=${Date.now()}`;
      const fallbackUrl = `${ALL_ORIGINS}${encodeURIComponent(
        UNODC_STORIES_URL
      )}&${cacheBuster}`;
      const response = await axios.get(fallbackUrl, { timeout: 15000 });
      return typeof response.data === "string" ? response.data : "";
    },

    async fetchStoriesFromMarkdown() {
      const cacheBuster = `cb=${Date.now()}`;
      const markdownUrl = `${MARKDOWN_STORIES_URL}?${cacheBuster}`;
      const response = await axios.get(markdownUrl, { timeout: 15000 });
      return typeof response.data === "string" ? response.data : "";
    },

    extractStoriesFromHtml(html) {
      if (!html || typeof html !== "string") {
        return [];
      }
      const stories = [];
      const seen = new Set();
      const parts = html.split('<div class="arch__item"');
      parts.shift();
      for (const part of parts) {
        const block = '<div class="arch__item"' + part;
        const dateMatch = block.match(/data-iso-date="([^"]*)"/i);
        const isoDate = dateMatch ? dateMatch[1] : "";
        const dateTextMatch = block.match(
          /<span[^>]*class="[^"]*std-item-date[^"]*"[^>]*>([^<]+)<\/span>/i
        );
        const fallbackDate = dateTextMatch ? dateTextMatch[1].trim() : "";
        const titleBlockMatch = block.match(
          /<div[^>]*class="[^"]*item__title[^"]*"[^>]*>([\s\S]*?)<\/div>/i
        );
        const titleBlock = titleBlockMatch ? titleBlockMatch[1] : block;
        const anchorMatch = titleBlock.match(
          /<a[^>]*href="([^"]+)"[^>]*>([\s\S]*?)<\/a>/i
        );
        if (!anchorMatch) {
          continue;
        }
        const href = anchorMatch[1];
        const rawTitle = anchorMatch[2] || "";
        const title = rawTitle.replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim();
        if (!href || !title) {
          continue;
        }
        const url = href.startsWith("http")
          ? href
          : new URL(href, UNODC_STORIES_URL).href;
        if (!url || seen.has(url)) {
          continue;
        }
        seen.add(url);
        const date = isoDate || fallbackDate;
        stories.push({ title, url, date });
        if (stories.length >= 30) {
          break;
        }
      }
      return stories;
    },

    extractStoriesFromMarkdown(markdown) {
      if (!markdown) {
        return [];
      }
      const regex =
        /\[([^\]]+)\]\((https?:\/\/www\.unodc\.org\/copak\/en\/Stories\/[^\)]+)\)/gi;
      const stories = [];
      const seen = new Set();
      let match;
      while ((match = regex.exec(markdown)) && stories.length < 30) {
        const title = (match[1] || "").trim();
        const url = (match[2] || "").trim();
        if (!title || !url || seen.has(url)) {
          continue;
        }
        seen.add(url);
        stories.push({ title, url, date: "" });
      }
      return stories;
    },

    formatStoryDay(date) {
      if (!date) return "--";
      const parts = date.split(/\s+/).filter(Boolean);
      return parts[0] || "--";
    },

    formatStoryMonth(date) {
      if (!date) return "";
      const parts = date.split(/\s+/).filter(Boolean);
      const month = parts[1] || "";
      return month ? month.slice(0, 3).toUpperCase() : "";
    },

    resetStoryRotation() {
      const chunkCount = this.storyChunks.length;
      this.storyBatchIndex = 0;
      this.storyBatchKey += 1;
      this.clearStoryTimer();
      if (chunkCount <= 1) {
        return;
      }
      this.storyTimer = setInterval(
        () => this.advanceStoryBatch(),
        this.storyRotationInterval
      );
    },

    advanceStoryBatch() {
      const chunkCount = this.storyChunks.length;
      if (chunkCount <= 1) {
        this.storyBatchIndex = 0;
        return;
      }
      this.storyBatchIndex = (this.storyBatchIndex + 1) % chunkCount;
      this.storyBatchKey += 1;
    },

    clearStoryTimer() {
      if (this.storyTimer) {
        clearInterval(this.storyTimer);
        this.storyTimer = null;
      }
    },

    clearLocalStorage() {
      localStorage.removeItem("currentUser");
      localStorage.removeItem("isPermission");
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      // Don't remove version as we want to keep track of it
    }
  },

  // created: function() {
      // this.basepath = "https://dev.tmisodc.org/dapi";
      // localStorage.setItem("BASE_PATH", "https://dev.tmisodc.org/dapi");
  // }
};
</script>

<style scoped>
body,
html {
  height: 100% !important;
  overflow: hidden;
  margin: 0;
}

.login-shell {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.bg {
  display: inline-flex;
  /* Full height */
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-blue {
  /* The image used */
  background-color: #00a6e4;
  float: right;
  /* Full height */
  height: 100%;
}

.btn-black {
  background-color: #354146 !important;
  color: #fff !important;
}

::placeholder {
  color: #cdcdcd !important;
  text-align: left;
}

.login-container {
  flex: 1;
  margin: 0;
  min-height: 0;
  overflow: hidden;
}

.mobile-logo {
  background-color: #00a6e4;
  padding: 20px 0;
}

.mobile-logo-img {
  max-width: 280px;
  margin: 0 auto;
}

.login-form-container {
  margin-top: 30px;
}

.desktop-logo {
  max-width: 360px;
  margin-bottom: -1.25rem;
}

/* Make left panel fill its column cleanly */
@media (min-width: 768px) {
  .left-panel {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    height: 100%;
    margin-top: 0;
    gap: 0;
  }
}

/* CLEANED-UP NEWS CARD */
.news-card {
  margin-top: 0.75rem;
  width: 120%;              /* 10% extra each side */
  max-width: 120%;
  height: 366px;            /* 20% taller than 280px */
  transform: translateX(-10%); /* center the 120% card */
  background: rgba(255, 255, 255, 0.85);
  border-radius: 18px;
  box-shadow: 0 30px 45px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  padding: 1.1rem 1.4rem;
  box-sizing: border-box;
  overflow: hidden;         /* no scroll; extra content is clipped */
}

/* Heading stays at top, list scrolls if needed */
.news-card-heading {
  font-size: 0.95rem;           /* slightly smaller to fit content */
  letter-spacing: 0.25em;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  color: #0b1a2a;
  flex-shrink: 0;
  
}

/* Fixed-height content area, no scrollbars */
.news-content {
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  padding-top: 10px;
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
}
.news-content::-webkit-scrollbar {
  width: 0;
}

.news-content:hover {
  scrollbar-width: thin;
  scrollbar-color: #0073c1 transparent;
}
.news-content:hover::-webkit-scrollbar {
  width: 6px;
}
.news-content:hover::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}
.news-content:hover::-webkit-scrollbar-thumb {
  background: #0073c1;
  border-radius: 3px;
}

/* Stacked list of stories */
.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;                  /* tighter spacing */
}

.news-list li {
  font-size: 0.85rem;           /* smaller text to fit */
  line-height: 1.25;
  padding-bottom: 14px;

}

.news-list a {
  color: #0056a3;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.news-list a:hover {
  text-decoration: underline;
}

/* Date icon stays fixed size */
.story-icon {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
    border-top: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.story-icon-month {
  width: 100%;
  padding: 0.08rem 0;
  background: #00a6e4;
  color: #fff;
  font-size: 0.55rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  text-align: center;
  border-radius: 8px 8px 0 0px;
}

.story-icon-day {
  font-size: 1.1rem;
  color: #131313;
}

.story-line {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.25rem;
}
.story-title {
  font-weight: 600;
  font-size: 0.9rem;
  flex: 1;
  min-width: 0;
}

.story-fade-enter-active,
.story-fade-leave-active {
  transition: opacity 0.7s ease;
}
.story-fade-enter,
.story-fade-leave-to {
  opacity: 0;
}

.login-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f2f2f2;
  color: #0056a3;
  text-align: center;
  padding: 0.5rem;
  font-size: 0.75rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  z-index: 10;
}

@media (min-width: 768px) {
  .login-form-container {
    margin-top: 110px;
  }
}

/* Adjust form inputs for better mobile experience */
.form-control {
  max-width: 100%;
  margin: 0;
}

.input-pill {
  position: relative;
  max-width: 320px;
  margin: 0 auto;
}

.input-icon {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  pointer-events: none;
}

.login-input {
  border-radius: 25px;
  padding: 12px 16px 12px 42px;
  height: auto;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 0.95rem;
  text-align: left;
}

.login-input:focus {
  border-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
}

/* Adjust button for mobile */
.btn-black {
  width: auto;
  margin: 0;
}

.btn-login {
  padding: 6px 64px;
  border-radius: 25px;
  letter-spacing: 0.08em;
  box-shadow: 0 12px 18px rgba(0, 0, 0, 0.25);
}

.forgot-wrapper {
  margin-top: 1.5rem;
}

.btn-outline-light {
  border: 1px solid rgba(255, 255, 255, 0.9);
  color: #fff;
  background: transparent;
  border-radius: 25px;
  padding: 6px 28px;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.1em;
}

.btn-outline-light:hover,
.btn-outline-light:focus {
  background: rgba(255, 255, 255, 0.15);
  border-color: #fff;
}

/* Tablet-specific styles */
@media (min-width: 768px) and (max-width: 1024px) {
  .tablet-logo {
    width: 340px !important;
    max-width: 100%;
  }

  .tablet-title {
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  .login-form-container {
    margin-top: 80px;
  }

  .form-control {
    max-width: 240px;
  }

  .btn-black {
    width: 160px;
    font-size: 0.9rem;
  }
}

/* Update existing responsive styles */
.login-form-container {
  margin-top: 30px;
}

@media (min-width: 1025px) {
  .login-form-container {
    margin-top: 110px;
  }
}

/* Adjust the existing logo styles */
.tablet-logo {
  width: 460px;
  max-width: 100%;
}

@media (min-width: 992px) {
  .input-pill {
    max-width: 360px;
  }

  .login-input {
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow: none;
    padding: 12px 16px 12px 40px;
    letter-spacing: 0.02em;
  }

  .input-icon {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
    left: 12px;
  }
}
</style>
